export default "__VITE_ASSET__d58c4e5d__"